import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Routes under `/cms/card-products/*` (see `CmsApp.tsx` + `cms-shell-layout.tsx`).
 * `:id` = product detail (limits on second tab).
 */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from 'shared/ui/error-boundary';
import CardProductsPage from 'pages/card-products-list.page';
import CardProductDetailsPageEntry from 'pages/card-product-details.page';
const CardProductRoutes = () => (_jsxs(Routes, { children: [_jsx(Route, { path: ":id", element: _jsx(ErrorBoundary, { children: _jsx(CardProductDetailsPageEntry, {}) }) }), _jsx(Route, { path: "*", element: _jsx(ErrorBoundary, { children: _jsx(CardProductsPage, {}) }) })] }));
/** Registered in `features/index.ts` for shell nav and router. */
export const CMS_NAV_ITEM = {
    id: 'card-products',
    pathSegment: 'card-products',
    labelKey: 'form.cardProduct',
    icon: 'pi pi-box',
    authorityKeys: ['ADMIN'],
    RoutesComponent: CardProductRoutes,
};
export default CardProductRoutes;
